// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  background-color: #ffffff;
  position: relative;
  padding: 0.75rem 0;
}

.navbar-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 3rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.navbar-logo {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.logo-icon {
  font-size: 1.5rem;
}

.navbar-logo h1 {
  margin: 0;
  color: #000000;
  font-size: 1rem;
  font-weight: 600;
}

.navbar-menu {
  display: flex;
  gap: 2rem;
  align-items: center;
  margin-left: 3rem;
}

.navbar-link {
  text-decoration: none;
  color: #212529;
  font-weight: 500;
  font-size: 0.85rem;
  transition: color 0.3s ease;
}

.navbar-link:hover {
  color: #28a745;
}

.navbar-actions {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  flex-wrap: wrap;
}

.btn-login {
  background-color: #ffffff;
  color: #212529;
  border: none;
  padding: 0.4rem 1rem;
  border-radius: 0.4rem;
  font-weight: 500;
  cursor: pointer;
  font-size: 0.85rem;
  transition: background-color 0.3s ease;
}

.btn-login:hover {
  background-color: #f5f5f5;
}

.btn-primary {
  background-color: #28a745;
  color: #ffffff;
  border: none;
  padding: 0.4rem 1rem;
  border-radius: 0.4rem;
  font-weight: 500;
  cursor: pointer;
  font-size: 0.85rem;
  transition: background-color 0.3s ease;
}

.btn-primary:hover {
  background-color: #218838;
}

.user-info {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-right: 1rem;
  gap: 0.25rem;
}

.word-balance {
  color: #28a745;
  font-weight: 600;
  font-size: 0.85rem;
}

.user-email {
  color: #64748b;
  font-size: 0.75rem;
}

@media (max-width: 1200px) {
  .navbar-container {
    padding: 0 2rem;
  }
  
  .navbar-menu {
    gap: 1.5rem;
  }
  
  .navbar-link {
    font-size: 0.8rem;
  }
}

@media (max-width: 768px) {
  .navbar-container {
    padding: 0 1rem;
  }
  
  
  .navbar-logo h1 {
    font-size: 0.9rem;
  }
  
  .navbar-menu {
    display: none;
  }
  
  .navbar-actions {
    gap: 0.5rem;
    flex-direction: column;
    align-items: flex-end;
  }
  
  .user-info {
    margin-right: 0.5rem;
  }
  
  .word-balance {
    font-size: 0.75rem;
  }
  
  .user-email {
    font-size: 0.7rem;
  }
  
  .btn-login,
  .btn-primary {
    font-size: 0.75rem;
    padding: 0.35rem 0.85rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/unAuth/components/NavBar.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;;EAGA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,kBAAkB;IAClB,wBAAwB;EAC1B;AACF","sourcesContent":[".navbar {\n  background-color: #ffffff;\n  position: relative;\n  padding: 0.75rem 0;\n}\n\n.navbar-container {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 0 3rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.navbar-logo {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.logo-icon {\n  font-size: 1.5rem;\n}\n\n.navbar-logo h1 {\n  margin: 0;\n  color: #000000;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.navbar-menu {\n  display: flex;\n  gap: 2rem;\n  align-items: center;\n  margin-left: 3rem;\n}\n\n.navbar-link {\n  text-decoration: none;\n  color: #212529;\n  font-weight: 500;\n  font-size: 0.85rem;\n  transition: color 0.3s ease;\n}\n\n.navbar-link:hover {\n  color: #28a745;\n}\n\n.navbar-actions {\n  display: flex;\n  gap: 0.75rem;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.btn-login {\n  background-color: #ffffff;\n  color: #212529;\n  border: none;\n  padding: 0.4rem 1rem;\n  border-radius: 0.4rem;\n  font-weight: 500;\n  cursor: pointer;\n  font-size: 0.85rem;\n  transition: background-color 0.3s ease;\n}\n\n.btn-login:hover {\n  background-color: #f5f5f5;\n}\n\n.btn-primary {\n  background-color: #28a745;\n  color: #ffffff;\n  border: none;\n  padding: 0.4rem 1rem;\n  border-radius: 0.4rem;\n  font-weight: 500;\n  cursor: pointer;\n  font-size: 0.85rem;\n  transition: background-color 0.3s ease;\n}\n\n.btn-primary:hover {\n  background-color: #218838;\n}\n\n.user-info {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  margin-right: 1rem;\n  gap: 0.25rem;\n}\n\n.word-balance {\n  color: #28a745;\n  font-weight: 600;\n  font-size: 0.85rem;\n}\n\n.user-email {\n  color: #64748b;\n  font-size: 0.75rem;\n}\n\n@media (max-width: 1200px) {\n  .navbar-container {\n    padding: 0 2rem;\n  }\n  \n  .navbar-menu {\n    gap: 1.5rem;\n  }\n  \n  .navbar-link {\n    font-size: 0.8rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .navbar-container {\n    padding: 0 1rem;\n  }\n  \n  \n  .navbar-logo h1 {\n    font-size: 0.9rem;\n  }\n  \n  .navbar-menu {\n    display: none;\n  }\n  \n  .navbar-actions {\n    gap: 0.5rem;\n    flex-direction: column;\n    align-items: flex-end;\n  }\n  \n  .user-info {\n    margin-right: 0.5rem;\n  }\n  \n  .word-balance {\n    font-size: 0.75rem;\n  }\n  \n  .user-email {\n    font-size: 0.7rem;\n  }\n  \n  .btn-login,\n  .btn-primary {\n    font-size: 0.75rem;\n    padding: 0.35rem 0.85rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
